export const ROOT_ROUTE = '/speed-to-market';
export const SPEED_TO_MARKET_NAV_CONFIG = [
	{
		path: `${ROOT_ROUTE}/category-widgets`,
		name: 'categoryWidgets',
		label: 'Category Widgets',
	},
];
